import { render, staticRenderFns } from "./wipcost.vue?vue&type=template&id=bb630ff0&scoped=true&"
import script from "./wipcost.vue?vue&type=script&lang=js&"
export * from "./wipcost.vue?vue&type=script&lang=js&"
import style0 from "./wipcost.vue?vue&type=style&index=0&id=bb630ff0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb630ff0",
  null
  
)

export default component.exports